import { useEffect } from 'react'

const useBgc = (pathname: string) => {
  const bgc: Record<string, string> = {
    general: `#000`,
  }

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
    document.documentElement.style.setProperty(
      '--bg-color',
      bgc[pathname] ?? '#000',
    )
  }, [])

  return null
}

export default useBgc
